import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"

type ButtonProps = {
    [key: string]: any
    loading?: boolean
    colour?: string
    text?: string
    children?: React.ReactNode
}

const LoadingButton = (props: ButtonProps) => {
    const {loading, colour, text, children, ...buttonProps} = props
    return (
        <Button {...buttonProps}>
            {loading ? (
                <>
                    {text !== undefined && <Typography sx={{fontSize: "12px", marginRight: "5px"}}>{text}</Typography>}
                    <CircularProgress
                        sx={colour !== undefined ? {color: `${colour}`} : {color: "#fff"}}
                        size="1.5rem"
                    />
                </>
            ) : (
                children
            )}
        </Button>
    )
}

export default LoadingButton
